import { useEffect, useState } from "react";
import { Form, Input, Button, Card, Typography, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";
import { sellBoostFetch } from "../../utlifyFunction";

const { Title, Paragraph } = Typography;

const LoginPage = () => {
	const [redirectLoading, setRedirectLoading] = useState(false)
	const [loading, setLoading] = useState(false);
	const {  setUserData } = useAuth();

	const onFinish = async (values) => {
		setLoading(true);
		const data = await sellBoostFetch("POST", "/shopify/installApp", {
			shop: values?.shop,
		});
		if (data?.url) {
			window.location.href = data?.url;
		} else {
			toast.error("Invalid shop URL. Please try again.");
			setLoading(false);
		}
	};

	const checkTokenValid = async (token) => {
		const data = await sellBoostFetch("POST", "/user/checkValidToken", { token });

		if (data?.token) {
			setUserData(data?.token?.userData);
			localStorage.setItem("SellBoostToken", token);

			if (data?.userData) {
				localStorage.setItem("SellBoostUser", JSON.stringify(data?.userData));
			}

			toast.success("Logged In Successfully!");
			window.location.replace("/");
		}
	};

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const redirectAuthToken = urlParams.get("redirectAuthToken");
		if (redirectAuthToken) {
			setRedirectLoading(true)
			checkTokenValid(redirectAuthToken);
		}
	}, []);

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
				background: "linear-gradient(135deg, #6D5BBA 0%, #8D58BF 50%, #FF80BF 100%)",
				padding: "20px",
			}}
		>
			<Spin spinning={redirectLoading}>
			<Card
				style={{
					width: 400,
					padding: "24px",
					borderRadius: "10px",
					boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
				}}
			>
				<Title level={2} style={{ textAlign: "center", marginBottom: "10px", color: "#333" }}>
					Login to SellBoost AI
				</Title>
				<Paragraph style={{ textAlign: "center", color: "#777", marginBottom: "20px" }}>
					Enter your Shopify store URL to continue.
				</Paragraph>

				<Form name="login" layout="vertical" onFinish={onFinish} autoComplete="off">
					<Form.Item
						label="Shopify Store URL"
						name="shop"
						rules={[
							{ required: true, message: "Please enter your Shopify store URL!" },
							{
								pattern: /[a-zA-Z0-9-]+\.myshopify\.com$/,
								message: "Enter a valid Shopify store URL (e.g., yourstore.myshopify.com)",
							},
						]}
					>
						<Input placeholder="yourstore.myshopify.com" autoComplete="on"/>
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit" block disabled={loading}>
							{loading ? <Spin indicator={<LoadingOutlined spin />} /> : "Login"}
						</Button>
					</Form.Item>
				</Form>
			</Card>
			</Spin>
		</div>
	);
};

export default LoginPage;
